import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

import { ERROR_MESSAGES } from "constants/validation";

/**
 * Stats Schema
 * Represents administrative transactions in the system
 * Base schema is loose to allow loading legacy data.
 */
export const StatsSchema = Yup.object().transform(transformSnakeToCamel).shape({
  links: Yup.number().nullable(),
  clicks: Yup.number().nullable(),
  uniques: Yup.number().nullable(),
  orders: Yup.number().nullable(),
  sales: Yup.number().nullable(),
  commission: Yup.number().nullable(),
  bonus: Yup.number().nullable(),
  earnings: Yup.number().nullable(),
});

/**
 * Stats Validation Schema
 * Strict rules applied only during form submission.
 */
export const StatsValidationSchema = StatsSchema.clone().shape({
  links: Yup.number().min(0, ERROR_MESSAGES.MIN_VALUE(0)),
  clicks: Yup.number().min(0, ERROR_MESSAGES.MIN_VALUE(0)),
  uniques: Yup.number().min(0, ERROR_MESSAGES.MIN_VALUE(0)),
  orders: Yup.number().min(0, ERROR_MESSAGES.MIN_VALUE(0)),
  sales: Yup.number().min(0, ERROR_MESSAGES.MIN_VALUE(0)),
  commission: Yup.number().min(0, ERROR_MESSAGES.MIN_VALUE(0)),
  bonus: Yup.number().min(0, ERROR_MESSAGES.MIN_VALUE(0)),
  earnings: Yup.number().min(0, ERROR_MESSAGES.MIN_VALUE(0)),
});

/**
 * Reusable schema for the dashboard date range filter
 * Used in Dashboard/index.js
 */
export const DateRangeSchema = Yup.object().shape({
  dateRange: Yup.object().shape({
    startDate: Yup.string().required(ERROR_MESSAGES.DATE_START_REQUIRED),
    endDate: Yup.string().required(ERROR_MESSAGES.DATE_END_REQUIRED),
  }),
});
